import React, { useState, useEffect } from 'react';

const ChequeDetailsModal = ({ isOpen, onClose, initialData, onSave }) => {
    const [details, setDetails] = useState({
        chequeNo: '',
        chequeDate: '',
        bankName: '',
        narration: ''
    });

    useEffect(() => {
        if (isOpen && initialData) {
            setDetails({
                chequeNo: initialData.chequeNo || '',
                chequeDate: initialData.chequeDate || '',
                bankName: initialData.chequeBankName || '',
                narration: initialData.chequeNarration || 'cheque'
            });
        }
    }, [isOpen, initialData]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 font-poppins">
            <div className="bg-white rounded shadow-lg w-[600px] overflow-hidden animate-scale-in">
                {/* Header */}
                <div className="bg-[#267c77] text-white p-3">
                    <h2 className="text-lg">धनादेश सविस्तर माहिती</h2>
                </div>

                <div className="p-8 space-y-6">
                    {/* Cheque No */}
                    <div className="flex items-center">
                        <label className="w-32 text-gray-700 text-lg">धनादेश नं.:</label>
                        <input 
                            type="text" 
                            value={details.chequeNo}
                            onChange={(e) => setDetails({ ...details, chequeNo: e.target.value })}
                            placeholder="धनादेश नं. भरा."
                            className="border border-[#267c77]/30 p-2 rounded flex-1 text-gray-700" 
                        />
                    </div>

                    {/* Date */}
                    <div className="flex items-center">
                        <label className="w-32 text-gray-700 text-lg">दिनांक:</label>
                        <input 
                            type="date" 
                            value={details.chequeDate}
                            onChange={(e) => setDetails({ ...details, chequeDate: e.target.value })}
                            className="border border-gray-300 p-2 rounded w-48 text-gray-700" 
                        />
                    </div>

                    {/* Bank Name */}
                    <div className="flex items-center">
                        <label className="w-32 text-gray-700 text-lg">बँकेचे नाव:</label>
                        <input 
                            type="text" 
                            value={details.bankName}
                            onChange={(e) => setDetails({ ...details, bankName: e.target.value })}
                            placeholder="बँकेचे नाव भरा."
                            className="border border-[#267c77]/30 p-2 rounded flex-1 text-gray-700" 
                        />
                    </div>

                    {/* Narration */}
                    <div className="flex items-start">
                        <label className="w-32 text-gray-700 text-lg mt-2">शेरा</label>
                        <textarea 
                            value={details.narration}
                            onChange={(e) => setDetails({ ...details, narration: e.target.value })}
                            placeholder="शेरा भरा."
                            rows="2"
                            className="border border-[#267c77]/30 p-2 rounded flex-1 text-gray-700 resize-none" 
                        />
                    </div>
                </div>

                {/* Footer */}
                <div className="bg-[#267c77] p-3 flex justify-center">
                    <button 
                        onClick={() => {
                            onSave(details);
                            onClose();
                        }}
                        className="bg-[#267c77] text-white px-8 py-1 rounded hover:bg-[#1e6b66] transition duration-200"
                    >
                        ठिक
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChequeDetailsModal;
